module.exports = __webpack_public_path__ + "img/btn_destination_preset.ddf2ec79.png";